import { render, staticRenderFns } from "./addAndEdit.vue?vue&type=template&id=74e356a0&scoped=true&"
import script from "./addAndEdit.vue?vue&type=script&lang=js&"
export * from "./addAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./addAndEdit.vue?vue&type=style&index=0&id=74e356a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e356a0",
  null
  
)

export default component.exports